import React from "react";
import {
  Button,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import { FaCheck, FaXmark } from "react-icons/fa6";

export default function ProcessDeleteionRequestModal({
  data,
  updateValue,
  onProcess,
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      {updateValue === "Approve" ? (
        <Tooltip label="Approve Request">
          <IconButton
            onClick={onOpen}
            bgColor="green.100"
            color="green.400"
            fontSize="lg"
            icon={<FaCheck />}
            isRound
          />
        </Tooltip>
      ) : (
        <Tooltip label="Disapprove Request">
          <IconButton
            onClick={onOpen}
            bgColor="red.100"
            color="red.400"
            fontSize="lg"
            icon={<FaXmark />}
            isRound
          />
        </Tooltip>
      )}
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="xl"
        scrollBehavior="inside"
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{updateValue} Deletion Request</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Are you sure you want to {updateValue} the deletion request?
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => {
                onProcess(data, updateValue);
                onClose();
              }}
              bgColor="black"
              borderRadius="lg"
              fontWeight="medium"
              py="6"
              px="7"
              me="2"
            >
              {updateValue}
            </Button>
            <Button
              onClick={() => onClose()}
              bgColor="gray.200"
              color="black"
              borderRadius="lg"
              fontWeight="medium"
              py="6"
              px="7"
            >
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
